<template>
  <tci-title :title="$t('contact.contact')" subtitle="CONTACT" :color="color">
      <v-row>
        <v-spacer></v-spacer>
        <v-col class="pa-0">
          <!-- 非手机端 -->
          <v-img
            position="left top"
            width="980"
            height="530" class="d-none d-sm-flex"
            src="../assets/bottom-2.jpg"
          >
            <v-row class="mx-2">
              <v-col>
                <v-list color="transparent" class="ml-12 mt-12">
                  <v-list-item>
                    <v-list-item-title class="headline">{{  $t('contact.company_name') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>{{  $t('contact.post_code') }}：215123</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>{{  $t('contact.address') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>TEL：+86-512-8666-5570</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>FAX：+86-512-8666-5571</v-list-item-title>
                  </v-list-item>
                  <v-list-item href="mailto:suzhou@trans-cosmos.com.cn">
                    <v-list-item-title>Email:suzhou@trans-cosmos.com.cn</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col class="px-2">
                <v-row justify="end" >
                  <v-col cols="auto" class="py-0">
                    <v-avatar class="mr-0" size="100" tile>
                      <v-img
                        src="../assets/qrcode.jpg"
                      ></v-img>
                    </v-avatar>
                  </v-col>
                </v-row>
                <v-divider class="my-2"></v-divider>
                <v-row >
                  <v-col class="py-0">
                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="name" :value="form.name" require dense ></v-text-field>
                  </v-col>
                  <v-col class="py-0">
                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="email" :value="form.email" require dense ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-text-field background-color="rgb(255, 255, 255, 0.4)" label="Subject" :value="form.subject" dense ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-textarea label="Message" dense
                    background-color="rgb(255, 255, 255, 0.4)" :value="form.message"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row class="mx-0">
                  <v-btn color="rgb(0, 0, 0, 0.4)" class="py-0 white--text" @click="contact" block>{{ $t('contact.button') }}</v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-img>
          <!-- 手机端 -->
          <v-img
            position="left top"
            class="d-flex d-sm-none"
            src="../assets/bottom-2-mobile.jpg"
          >
            <v-card color="transparent" flat>
              <div class="d-flex flex-no-wrap justify-space-between">
                <v-card-title>{{ $t('contact.company_name') }}</v-card-title>
                <v-avatar
                class="mr-3 mt-3"
                size="80"
                tile
              >
                <v-img src="../assets/qrcode.jpg"></v-img>
              </v-avatar>
              </div>
            </v-card>
            
            <v-row class="mt-0">
              <v-col class="py-0">
                <v-list color="transparent" class="my-0">
                  <v-list-item>
                    <v-list-item-title>{{  $t('contact.post_code') }}：215123</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title class="text-wrap">{{  $t('contact.address') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>TEL：+86-512-8666-5570</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>FAX：+86-512-8666-5571</v-list-item-title>
                  </v-list-item>
                  <v-list-item href="mailto:suzhou@trans-cosmos.com.cn">
                    <v-list-item-title>Email:suzhou@trans-cosmos.com.cn</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col class="px-2">
                <v-divider class="py-4"></v-divider>
                <v-row >
                  <v-col class="py-0" cols="12">
                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="name" :value="form.name" require dense ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12">
                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="email" :value="form.email" require dense ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12">
                    <v-text-field class="px-4" background-color="rgb(255, 255, 255, 0.1)" label="Subject" :value="form.subject" dense ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12">
                    <v-textarea label="Message" dense class="px-4"
                    background-color="rgb(255, 255, 255, 0.4)" :value="form.message"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row class="mx-4 my-12">
                  <v-btn color="rgb(0, 0, 0, 0.4)" class="py-0 white--text" @click="contact" block>{{ $t('contact.button') }}</v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-img>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <tci-scroll color="black" icon="mdi-chevron-double-up"></tci-scroll>
    </tci-title>
</template>

<script>
import TciScroll from "@/components/TciScroll.vue";
import TciTitle from "./TciTitle.vue";

export default {
    name: 'TciContactFooter',
    components: {
      "tci-title": TciTitle,
      "tci-scroll": TciScroll,
    },
    data: () => ({
      form:{
        subject:"",
        message:"",
        name:"",
        email:""
      }
    }),
    props: {
      "color": String
    },
    methods: {
      contact: function(){
        window.open("mailto:suzhou@trans-cosmos.com.cn?cc="+this.form.email+"subject="+this.form.subject+"&body="+this.form.body);
      }
      
    }
  
}
</script>
